import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "py-0" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "banner__inner f-direction" }
const _hoisted_4 = { class: "banner__content" }
const _hoisted_5 = { class: "flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", {
  class: "icon-user mr-4",
  style: {"font-size":"70px"}
}, null, -1)
const _hoisted_7 = { class: "" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "banner__description" }
const _hoisted_11 = { class: "grid grid--ub" }
const _hoisted_12 = {
  key: 0,
  class: "col flex-none"
}
const _hoisted_13 = {
  class: "field align-items-center grid align-items-unset",
  style: {"min-height":"27px"}
}
const _hoisted_14 = { class: "col" }
const _hoisted_15 = {
  class: "field align-items-center grid align-items-unset",
  style: {"min-height":"27px"}
}
const _hoisted_16 = { class: "col" }
const _hoisted_17 = {
  key: 0,
  class: "field align-items-center grid bg-color-red pt-2 pb-2"
}
const _hoisted_18 = { class: "col" }
const _hoisted_19 = {
  key: 1,
  class: "col p-m"
}
const _hoisted_20 = { style: {"margin":"8px 0"} }
const _hoisted_21 = { style: {"margin":"8px 0"} }
const _hoisted_22 = {
  class: "col flex align-items-center justify-content no-border",
  style: {"padding-right":"20px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconTextBlock = _resolveComponent("IconTextBlock")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["banner banner--bland", { 'banner--admin': _ctx.isAdmin }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                (_ctx.data.firstname)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.data.firstname), 1))
                  : _createCommentVNode("", true),
                (_ctx.data.lastname)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.data.lastname), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              (_ctx.data.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", {
                        class: "col fw-unset",
                        style: _normalizeStyle(
                      'max-width:' +
                      _ctx.colWidth +
                      'px; min-width:' +
                      _ctx.colWidth +
                      'px'
                    )
                      }, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.t("content.settings.banner.titleName")) + ":", 1)
                      ], 4),
                      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.data.userTitleName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", {
                        class: "col fw-unset",
                        style: _normalizeStyle(
                      'max-width:' +
                      _ctx.colWidth +
                      'px; min-width:' +
                      _ctx.colWidth +
                      'px'
                    )
                      }, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.t("content.settings.banner.expertFieldName")) + ":", 1)
                      ], 4),
                      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.data.expertFieldName), 1)
                    ]),
                    (_ctx.isAdmin)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("div", {
                            class: "col",
                            style: _normalizeStyle(
                      'max-width:' +
                      _ctx.colWidth +
                      'px; min-width:' +
                      _ctx.colWidth +
                      'px'
                    )
                          }, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.t("content.settings.banner.roleName")) + ":", 1)
                          ], 4),
                          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.data.roleName), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.data.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("p", _hoisted_20, [
                      _createVNode(_component_IconTextBlock, {
                        style: {"min-height":"27px"},
                        icon: "icon-phone",
                        label: _ctx.data.phoneNumber
                      }, null, 8, ["label"])
                    ]),
                    _createElementVNode("p", _hoisted_21, [
                      _createVNode(_component_IconTextBlock, {
                        style: {"min-height":"27px"},
                        icon: "icon-envelope",
                        label: _ctx.data.email
                      }, null, 8, ["label"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_Button, {
                  type: "button",
                  class: "p-button-iconEdge minWidth",
                  icon: "icon-chevron-right",
                  "icon-pos": "right",
                  label: _ctx.t('content.settings.banner.logoutButton'),
                  onClick: _ctx.onLogoutAction
                }, null, 8, ["label", "onClick"])
              ])
            ])
          ])
        ])
      ])
    ], 2)
  ]))
}